




















































































































































import Vue from 'vue'
import {NOTARY} from '@/api/NOTARY'
import {Appointment} from '@/models/Appointment'
import VeeDate from '@/components/forms/VeeDate.vue'
import moment from 'moment'
import {dateFormat, dateTimeFormat, formatTime} from '@/helpers/date-formats'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue'
import ErrorToaster from '@/views/app/ErrorToaster.vue'
import {mapState} from "vuex";
import {State as StaticState} from "@/store/statics";


interface SyntheticEvent {
  bubbles: boolean;
  cancelable: boolean;
  currentTarget: EventTarget;
  defaultPrevented: boolean;
  eventPhase: number;
  isTrusted: boolean;
  nativeEvent: Event;

  preventDefault(): void;

  stopPropagation(): void;

  target: EventTarget;
  timeStamp: Date;
  type: string;
}

export default Vue.extend({
  components: {ErrorToaster, VeeDate, ConfirmDialog},
  data() {
    return {
      appointments: [] as Appointment[],
      events: [] as any[],
      fetchError: {},
      deleteError: {},
      colors: ['blue', 'red', 'deep-purple', 'green', 'brown', 'orange', 'grey darken-1'],
      selectedEvent: {} as { data: {} },
      selectedAppointment: null as Appointment | null,
      selectedElement: null as {} | null,
      selectedOpen: false,
      loading: true,
      confirmDialog: false,
      selectedDate: moment().format(dateFormat),
    }
  },
  sockets: {
    new_activity: function(activity) {
      if (activity.entityName === 'appointments') {
        const activityDate = moment(activity.entity.startDate, dateTimeFormat).format(dateFormat)
        if (activityDate === this.$data.selectedDate) {
          (this as Vue & { customFetch: () => void }).customFetch()
        }
      }
    }
  },
  computed: {
    ...mapState('statics', {
      rooms: (state: StaticState) => state.rooms.map(room => room.name),
    }),
  },
  mounted() {
    (this.$refs.calendar as Vue & { checkChange: () => void }).checkChange()
  },
  created() {
    const localStorageDate = window.localStorage.getItem('appointments_initial_date')
    if (localStorageDate && moment(localStorageDate).isValid()) {
      this.selectedDate = moment(localStorageDate).format(dateFormat)
    }
    this.customFetch()
  },
  methods: {
    formatTime: formatTime,
    async customFetch () {
      this.loading = true
      try {
        const responses = await Promise.all([
          NOTARY.get(`appointments?startDate=${this.selectedDate}`)
        ])
        const appointments = responses[0]
        if (appointments.data) {
          this.appointments = appointments.data
              .map((appointment: Appointment) => {
                return {
                  ...appointment,
                  roomName: appointment?.room?.name
                }
              }) as Appointment[]
        }
      } catch (e) {
        this.fetchError = e
      }
      this.loading = false
    },
    editItem: function (item: Appointment) {
      const id = String(item.id)
      this.$router.push({
        name: 'AppointmentsEdit',
        params: {id}
      })
    },
    deleteItem: async function (item: Appointment) {
      try {
        await NOTARY.delete(`appointments/${item.id}`)
        this.appointments = this.appointments.filter(appointment => {
          return appointment.id !== this.selectedAppointment?.id
        })
      } catch (e) {
        this.deleteError = e
      }
    },
    confirmDeletion: function () {
      if (this.selectedAppointment) {
        this.deleteItem(this.selectedAppointment)
      }
    },
    showEvent: function ({nativeEvent, event}: { nativeEvent: SyntheticEvent; event: { data: {} } }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedAppointment = event.data as Appointment
        this.selectedElement = nativeEvent.target
        setTimeout(() => {
          this.selectedOpen = true
        }, 10)
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    createAppointment: function () {
      this.$router.push({
        name: 'AppointmentsNew'
      })
    },
    getEventColor(event: { color: string }) {
      return event.color
    },
  },
  watch: {
    selectedDate: function () {
      window.localStorage.setItem('appointments_initial_date', this.selectedDate)
      this.customFetch()
    },
    appointments: function () {
      this.events = this.appointments.map(appointment => {
        return {
          name: appointment.name,
          start: moment(appointment.startDate).format(dateTimeFormat),
          end: moment(appointment.endDate).format(dateTimeFormat),
          color: this.colors[appointment.roomId - 1],
          timed: false,
          category: appointment.roomName,
          data: appointment
        }
      })
    }
  }
})
